module.exports = __webpack_public_path__ + "6445d0371b72defd7ed36a9ac62dd7bc.woff";